// Sends the logged in user's username and email to Crisp, so operators
// see the real user in the Inbox instead of "Visitor".
export default ({ store }) => {
  const setCrispUser = async () => {
    if (!store.getters['user/isLoggedIn']) {
      return
    }

    try {
      const personalData = await store.dispatch('user/getPersonalData')

      window.$crisp = window.$crisp || []

      if (personalData?.email) {
        window.$crisp.push(['set', 'user:email', [personalData.email]])
      }

      if (personalData?.username) {
        window.$crisp.push(['set', 'user:nickname', [personalData.username]])
      }
    } catch (e) {
      console.log(e)
    }
  }

  const workflowId = 'scenario_91007957-7682-4fa3-8bc1-0b3e2f9601c2'
  const workflowStartedKey = 'workflow_started'
  const storageKey = (sessionId) => `crisp_${workflowStartedKey}_${sessionId}`

  // The workflow runs once per conversation.
  const isWorkflowStarted = (sessionId) => {
    if (window.$crisp.get('session:data', workflowStartedKey)) {
      return true
    }

    try {
      return !!sessionId && localStorage.getItem(storageKey(sessionId)) === '1'
    } catch (e) {
      return false
    }
  }

  const markWorkflowStarted = (sessionId) => {
    window.$crisp.push(['set', 'session:data', [[[workflowStartedKey, true]]]])

    try {
      if (sessionId) {
        localStorage.setItem(storageKey(sessionId), '1')
      }
    } catch (e) {}
  }

  // the workflow is requested at most once per page load
  let workflowRequested = false

  const runWorkflowOnce = () => {
    const sessionId = window.$crisp.get('session:identifier')

    if (
      workflowRequested ||
      window.$crisp.is('session:ongoing') ||
      isWorkflowStarted(sessionId)
    ) {
      return
    }

    workflowRequested = true
    window.$crisp.push(['do', 'bot:scenario:run', [workflowId]])
  }

  // The workflow counts as started only when its first message arrives,
  // so a run that did not start is tried again after a page load.
  const confirmWorkflowStarted = () => {
    if (workflowRequested) {
      markWorkflowStarted(window.$crisp.get('session:identifier'))
    }
  }

  // the handlers are registered only once, even if the plugin runs again
  if (!window.crispWorkflowHandlerRegistered) {
    window.crispWorkflowHandlerRegistered = true
    window.$crisp = window.$crisp || []
    window.$crisp.push(['on', 'chat:opened', runWorkflowOnce])
    window.$crisp.push(['on', 'message:received', confirmWorkflowStarted])
  }

  // page load with a persisted login
  setCrispUser()

  // login and impersonation
  store.watch(
    (state) => state.user.userId,
    (userId) => {
      if (userId) {
        setCrispUser()
      }
    }
  )
}
